// The cart as a side sheet, opened from the header button on any page.
import { Link, useLocation } from "react-router-dom";
import { CartView } from "./CartView";
import { StoreDialog } from "./StoreDialog";
import { useStore } from "./StoreSession";

export function CartDrawer() {
  const store = useStore();
  const location = useLocation();
  return <StoreDialog title="Your cart" onClose={store.closeDialog} placement="side" className="cart-drawer">
    <CartView returnPath={location.pathname + location.search}/>
    {store.signedIn && (store.cart?.lines.length ?? 0) > 0 && <Link className="text-link" to="/store/cart">Open the cart as a page</Link>}
  </StoreDialog>;
}
